import { dbPost } from '../../apis/commonApi';

class ProcessController {
  headerList = [
    {
      colNo: 0,
      key: 'selected',
      labelType: 'check',
      dataType: 'check',
      name: '선택',
      readonly: false,
    },
    {
      colNo: 1,
      key: 'tpbizTypeNm',
      labelType: 'text',
      dataType: 'text',
      name: '업종',
      readonly: true,
    },
    {
      colNo: 2,
      key: 'taskNm',
      labelType: 'text',
      dataType: 'text',
      name: '공정명',
    },
    {
      colNo: 3,
      key: 'regDt',
      labelType: 'text',
      dataType: 'text',
      name: '등록일자',
    },
    {
      colNo: 4,
      key: 'prevRsrchDt',
      labelType: 'text',
      dataType: 'text',
      name: '이전조사일자',
    },
    {
      colNo: 5,
      key: 'nextRsrchDt',
      labelType: 'text',
      dataType: 'text',
      name: '다음조사일자',
    },
    {
      colNo: 6,
      key: 'rsrchBgng',
      labelType: 'text',
      dataType: 'link',
      name: '조사시작',
    },
  ];

  constructor(
    store,
    modalService,
    validateService,
    refs,
    [searchParam, setSearchParam],
    { valueObj, setValueObj, dataList, setDataList },
    navigate // navigate 함수를 인자로 받음
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.tableRef = refs[0];
    this.navigate = navigate; // navigate 함수를 저장
    this.searchParam = searchParam;
    this.setSearchParam = setSearchParam;
    this.dataList = dataList;
    this.setDataList = setDataList;
    this.valueObj = { ...valueObj };
    this.setValueObj = setValueObj;
    this.selectedInfo = [];
  }

  async init() {
    await this.setSearchParam({
      entSn: this.store.entSn,
      currentPage: 1,
      pageSize: 10,
    });

    await this.setValueObj({
      entSn: this.store.entSn || this.valueObj.entSn,
    });

    // this.loadTaskOptions();
    this.loadTpbizOptions();
    this.getTask();
  }

  //공정관리 그리드 값
  async getTask(currentPage = 1) {
    const validationRules = {
      entSn: { presence: true },
    };

    const altKey = {
      entSn: '기업',
    };

    if (
      await this.validateService.validateJsCall(
        this.searchParam,
        validationRules,
        altKey
      )
    ) {
      return;
    }

    const url = '/aia/process/info.do';

    let response = await dbPost(url, { ...this.searchParam, currentPage });

    if (response && Array.isArray(response)) {
      const updatedDataList = response.map((item, index) => {
        const prevRsrchDt = item.chckRegDt === null ? '미조사' : item.chckRegDt;
        const nextRsrchDt = prevRsrchDt === '미조사' ? null : item.regDtPlus3y;

        return {
          totalCount: item.totalCount,
          rowNo: index,
          tpbizTypeNm: item.tpbizTypeNm,
          taskId: item.taskId,
          taskNm: item.comCdNm,
          regDt: item.regDt,
          prevRsrchDt: prevRsrchDt,
          nextRsrchDt: nextRsrchDt,
          rsrchBgng: '조사시작',
          selected: false,
        };
      });
      this.setDataList(updatedDataList);
      if (this.tableRef.current) {
        this.tableRef.current.resetData(updatedDataList);
      }
    }
  }

  //공정 리스트
  async loadTaskOptions(tpbizTypeId) {
    const url = '/aia/task/name.do';
    const param = { tpbizTypeId: tpbizTypeId };

    let response = await dbPost(url, param);
    if (response && Array.isArray(response)) {
      const updatedValueObj = {
        taskOptions: response.map(option => ({
          comCd: option.comCd,
          comCdNm: option.comCdNm,
        })),
        taskNm: '',
      };
      this.setValueObj(prev => ({ ...prev, ...updatedValueObj }));
    }
  }

  //업종 리스트
  async loadTpbizOptions() {
    const url = '/aia/tpbiz/type.do';
    const param = {};

    let response = await dbPost(url, param);
    if (response && Array.isArray(response)) {
      const updatedValueObj = { tpbizOptions: response }; // response를 valueObj에 추가
      this.setValueObj(prev => ({ ...prev, ...updatedValueObj })); // 업데이트
    }
  }

  //공정저장
  async fnSave() {
    const { entSn, tpbizTypeId, comCd, comCdNm2, taskExpln } = this.valueObj;

    let taskNm = '';
    let insertOrUpdate = '';

    if (comCd === 'all' && comCdNm2) {
      taskNm = comCdNm2;
    } else {
      taskNm = this.valueObj.taskNm;
      insertOrUpdate = 'update';
    }

    if (!tpbizTypeId || !comCd || !taskExpln || !taskNm) {
      this.modalService.noticeAlert('모든 필수 정보를 입력해 주세요.');
      return;
    }

    const doSave = async () => {
      const url = '/aia/process/add.do';
      const param = {
        entSn: entSn,
        tpbizTypeId: tpbizTypeId, // 업종 ID
        taskNm: this.valueObj.taskNm, // 공정명
        taskExpln: taskExpln, // 상세 내용
        insertOrUpdate: insertOrUpdate !== 'update' ? 'insert' : insertOrUpdate, // insert or update
        atrb2: comCd !== 'all' ? comCd : '', // 공정 공통코드 원본 공정ID
      };

      try {
        const response = await dbPost(url, param);
        if (response === '저장이 완료되었습니다.') {
          this.modalService.successAlert(response);
          // this.resetValueObj(this.valueObj);
          this.getTask();
          this.loadTaskOptions(param.tpbizTypeId);
        } else {
          this.modalService.errorAlert(response);
        }
      } catch (error) {
        this.modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
      }
    };

    this.modalService.confirmAlert({ msg: '저장하시겠습니까?' }, [
      doSave,
      () => {},
    ]);
  }

  toggleTaskNameEditable(editable) {
    this.setValueObj(prev => ({
      ...prev,
      isTaskNameEditable: editable,
    }));
  }

  //공정 삭제
  async fnDelete() {
    let tableData = this.tableRef.current.getDataList();

    let deleteList = [];

    for (let index = 0; index < tableData.length; index++) {
      const data = tableData[index];

      if (data.selected === true) {
        deleteList.push(data.taskId);
      }
    }

    if (deleteList.length === 0) {
      this.modalService.errorAlert('삭제할 공정을 선택해 주세요.');
      return;
    }

    const doDelete = async () => {
      const url = '/aia/process/remove.do';
      try {
        for (const row of deleteList) {
          const param = {
            taskId: row,
          };
          const response = await dbPost(url, param);
          if (response instanceof Error) {
            this.modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
            return;
          }
        }
        this.modalService.successAlert('삭제가 완료되었습니다.');
        this.getTask();
        // this.init();
      } catch (error) {
        this.modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
      }
    };

    this.modalService.confirmAlert({ msg: '삭제하시겠습니까?' }, [
      doDelete,
      () => {},
    ]);
  }

  // 테이블 헤더 체크박스
  async tableHeaderClick(info) {
    let tableData = this.tableRef.current.getDataList();

    if (info.keyVal === 'selected') {
      for (let index = 0; index < tableData.length; index++) {
        tableData[index].selected = info.val;
      }

      this.tableRef.current.setDataList(tableData);
    }
  }

  //테이블 체크 박스
  async tableCellClick(info) {
    if (info.key === 'rsrchBgng') {
      const rowData = this.dataList[info.rowNo];

      const state = {
        flag: 'new',
        entSn: this.store.entSn,
        taskId: rowData.taskId,
      };

      sessionStorage.setItem('surveyCheckState', JSON.stringify(state));

      this.navigate('/ai/surveyCheck', {
        state,
      });
    }
  }

  // valueObj 초기화
  resetValueObj(valueObj) {
    this.setValueObj(prev => ({
      ...prev,
      tpbizTypeId: '',
      comCdNm: '',
      comCdNm2: '',
      taskExpln: '',
      comCd: '',
      taskNm: '',
      isTaskNameEditable: false,
    }));
  }

  // valueObj 변경
  async valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }

  async searchParamChange(model, value) {
    if (model === 'entSn') {
      this.setValueObj(prev => ({ ...prev, entSn: value }));
      this.setSearchParam(prev => ({ ...prev, [model]: value }));
    }
    if (model === 'currentPage') {
      this.getTask(value);
    } else {
      this.setSearchParam(prev => ({ ...prev, [model]: value }));
    }
  }
}

export default ProcessController;
